import { UIHeading4, UIText2, Image } from '@cian/ui-kit';
import classNames from 'classnames';
import * as React from 'react';

import * as styles from './Notification.css';
import { ImageNone } from '../ImageNone';

const OPEN_CHAT_URL = 'https://www.cian.ru/dialogs/?chatId=';

interface INotificationProps {
  imageUrl: string;
  title: string;
  message: string;
  isOffer: boolean;
  chatId: string;
  onClick: () => void;
}

export const Notification: React.FC<INotificationProps> = ({ imageUrl, title, message, isOffer, chatId, onClick }) => {
  const handleClick = React.useCallback(() => {
    const link = `${OPEN_CHAT_URL}${chatId}`;
    window.open(link, '_blank');
    onClick();
  }, [chatId, onClick]);

  return (
    <div
      className={classNames(styles['wrapper'])}
      onClick={e => {
        e.preventDefault();
        handleClick();
      }}
    >
      <UIHeading4 color="text-inverted-default">Новое сообщение</UIHeading4>
      <div className={classNames(styles['content'])}>
        <div className={styles['imageUrl']}>
          {imageUrl ? (
            <Image width={40} height={40} objectFit="cover" src={imageUrl} />
          ) : (
            <ImageNone type={isOffer ? 'offer' : 'agent'} />
          )}
        </div>
        <div className={styles['text']}>
          <div className={styles['title']}>
            <UIText2 color="text-inverted-default">{title}</UIText2>
          </div>
          <div className={styles['message']}>
            <UIText2 color="text-inverted-disabled">{message}</UIText2>
          </div>
        </div>
      </div>
    </div>
  );
};
